module.exports = __webpack_public_path__ + "img/y7.e8fcfd88.jpg";